import payPanel from './payPanel.vue'

export default {
  extends: payPanel
}



// WEBPACK FOOTER //
// ./src/components/commonPayPanel/func-payPanel.js